export default function LegalNotices({ t, lang, setLang }) {
    return (
        <div className="container my-5" style={{ maxWidth: "1000px" }}>

        <section className="mb-5 text-start">
            <h5 className="mb-3 pb-2" style={{fontFamily:'pangram-sans-semiBold', fontSize:'1.6rem'}}>Éditeur du site</h5>
            <p className="text-muted">
            GAILO GAILO<br />
            Contact : guiliabarbini@me.com
            </p>
        </section>

        <section className="mb-5 text-start">
            <h5 className="mb-3 pb-2" style={{fontFamily:'pangram-sans-semiBold', fontSize:'1.6rem'}}>Hébergement</h5>
            <p className="text-muted">
            OVH Cloud<br />
            2 rue Kellermann - 59100 Roubaix - France<br />
            </p>
        </section>

        <section className="mb-5 text-start">
            <h5 className="mb-3 pb-2" style={{fontFamily:'pangram-sans-semiBold', fontSize:'1.6rem'}}>Propriété intellectuelle</h5>
            <p className="text-muted">
            L’ensemble des contenus présents sur ce site (textes, photographies,
            vidéos, œuvres, créations graphiques) sont protégés par le droit d’auteur.
            Toute reproduction ou représentation, totale ou partielle, est interdite
            sans autorisation écrite préalable.
            </p>
        </section>

        <section className="mb-5 text-start">
            <h5 className="mb-3 pb-2" style={{fontFamily:'pangram-sans-semiBold', fontSize:'1.6rem'}}>Responsabilité</h5>
            <p className="text-muted">
            Les informations diffusées sur ce site sont fournies à titre indicatif.
            L’éditeur ne saurait être tenu responsable des omissions ou inexactitudes.
            </p>
        </section>

        <section className="mb-5 text-start">
            <h5 className="mb-3 pb-2" style={{fontFamily:'pangram-sans-semiBold', fontSize:'1.6rem'}}>Données personnelles</h5>
            <p className="text-muted">
            Les données éventuellement collectées via le formulaire de contact sont
            utilisées uniquement pour répondre aux demandes. Conformément au RGPD,
            vous pouvez exercer votre droit d’accès, de modification ou de suppression
            en contactant : contact@juliehuguet.com
            </p>
        </section>

          <section className="mb-5 text-start">
            <h5 className="mb-3 pb-2" style={{fontFamily:'pangram-sans-semiBold', fontSize:'1.6rem'}}>Contenus intégrés (YouTube)</h5>
            <p className="text-muted">
            Certaines vidéos présentes sur ce site sont intégrées depuis la plateforme YouTube.
            Lors de la consultation de ces vidéos, des cookies peuvent être déposés par YouTube
            afin de permettre la lecture du contenu et d’effectuer des mesures d’audience.
            <br /><br />
            Ces données sont collectées directement par YouTube (Google Ireland Limited)
            conformément à leur propre politique de confidentialité.
            Nous vous invitons à consulter leur politique de confidentialité pour plus d’informations :
            https://policies.google.com/privacy
            </p>
        </section>

        </div>
        
    )
}